define('models/WorkItemInteraction',[
    'lib/knockout',
    'util/ObservableModel'
], function (
    ko,
    ObservableModel
) {
    'use strict';

    return ObservableModel.extend({
        defaults: {
            workItemId: '',
            simpleScriptCallback: null
        }
    }, function () {
        var self = this;

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                "unwrap"
            ]);
        };
    });
});

